export default "__VITE_ASSET__Brn8zKjn__"